// extracted by mini-css-extract-plugin
module.exports = {"container":"WCSNoverification_container__5wdXH","button":"WCSNoverification_button__2I9_z","overlay":"WCSNoverification_overlay__1aa0w","help":"WCSNoverification_help__3qHCn"};